import React from 'react';
import { Navigate } from 'react-router-dom';
import { useStateContext } from '../components/contexts/ContextProvider';
import LoadContentSpinner from '../components/Utils/LoadContentSpinner';

const PrivateRoute = ({ children }) => {
    const { token, loading } = useStateContext();

    if (loading) {
        return <LoadContentSpinner />;
    }

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default PrivateRoute;
